import { render, staticRenderFns } from "./steelBoxFan.vue?vue&type=template&id=56792b83&scoped=true"
import script from "./steelBoxFan.vue?vue&type=script&lang=js"
export * from "./steelBoxFan.vue?vue&type=script&lang=js"
import style0 from "./steelBoxFan.vue?vue&type=style&index=0&id=56792b83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56792b83",
  null
  
)

export default component.exports